export const FETCH_ADVERTISING_HOMEBLOCK = "FETCH_ADVERTISING_HOMEBLOCK" as const;
export const FETCH_ADVERTISING_HOMEBLOCK_SUCCESS = "FETCH_ADVERTISING_HOMEBLOCK_SUCCESS" as const;
